"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Experience = void 0;
var BehaviourExecution_1 = require("./BehaviourExecution");
var BehaviourMetrics_1 = require("./BehaviourMetrics");
var IdentityMetrics_1 = require("./IdentityMetrics");
var BehaviourExecutionDetail_1 = require("./BehaviourExecutionDetail");
/**
 * Container type for runtime information
 */
var Experience = /** @class */ (function (_super) {
    __extends(Experience, _super);
    function Experience() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Experience";
        _this.behaviourExecution = function (identityId, processInstanceId, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("processInstanceId", processInstanceId);
            var entity = new BehaviourExecutionDetail_1.BehaviourExecutionDetail();
            config(entity);
            return "behaviourExecution(identityId:" + name1 + ", processInstanceId:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.behaviourExecutions = function (identityId, limit, offset, startDate, endDate, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("startDate", startDate);
            var name5 = registry.register("endDate", endDate);
            var entity = new BehaviourExecution_1.BehaviourExecution();
            config(entity);
            return "behaviourExecutions(identityId:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", startDate:" + name4 + ", endDate:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.identityMetrics = function (identityId, startDate, endDate, limit, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("startDate", startDate);
            var name3 = registry.register("endDate", endDate);
            var name4 = registry.register("limit", limit);
            var entity = new IdentityMetrics_1.IdentityMetrics();
            config(entity);
            return "identityMetrics(identityId:" + name1 + ", startDate:" + name2 + ", endDate:" + name3 + ", limit:" + name4 + "){" + entity.render(registry) + "}";
        }); };
        _this.behaviourMetrics = function (identityId, behaviourId, startDate, endDate, limit, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("behaviourId", behaviourId);
            var name3 = registry.register("startDate", startDate);
            var name4 = registry.register("endDate", endDate);
            var name5 = registry.register("limit", limit);
            var entity = new BehaviourMetrics_1.BehaviourMetrics();
            config(entity);
            return "behaviourMetrics(identityId:" + name1 + ", behaviourId:" + name2 + ", startDate:" + name3 + ", endDate:" + name4 + ", limit:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Experience;
}(Array));
exports.Experience = Experience;
//# sourceMappingURL=Experience.js.map